/**
 * The rule the sign-in form already applies before it will let a customer send themselves a link
 * (see SignInWithMagicLink.tsx): the backend's InitiateRequest.otp field is a 6-digit TOTP, so a
 * valid entry is exactly six digits and nothing else. Extracted here so a second consumer
 * (LinkSentSignInResend's own `freshCode` field, on the returning-customer sign-in route) checks a
 * typed code against the same rule this form already uses, rather than a second,
 * independently-maintained regex that could quietly drift from it.
 */
export const AUTHENTICATOR_CODE_PATTERN = /^\d{6}$/;

export function isValidAuthenticatorCode(code: string): boolean {
  return AUTHENTICATOR_CODE_PATTERN.test(code);
}
